import { lazy } from "react";

const CreateNotiSegmentPage = lazy(() => import("./create"));
const NotiSegmentListPage = lazy(() => import("./main"));
const UpdateNotiSegmentPage = lazy(() => import("./update"));

export {
  CreateNotiSegmentPage, NotiSegmentListPage, UpdateNotiSegmentPage,
};
